"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _uuid = require("uuid");

var _Dropdown = _interopRequireDefault(require("../Dropdown/Dropdown"));

var _Tabs = _interopRequireDefault(require("../Tabs/Tabs"));

var _DropdownWithCheckbox = require("../DropdownWithCheckbox/DropdownWithCheckbox");

var _Checkbox = _interopRequireDefault(require("../Checkbox/Checkbox"));

var _Dropdown2 = require("../Dropdown/Dropdown.styles");

var _hooks = require("../../hooks");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var selectAllId = (0, _uuid.v4)();
var Menu = _Dropdown["default"].Menu;

var filterList = function filterList() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var lowercasedValue = value.toLowerCase();
  return array.filter(function (_ref) {
    var label = _ref.label;
    return label.toLowerCase().indexOf(lowercasedValue) > -1;
  });
}; // otherProps are for Dropdown component


var DropdownWithTabs = function DropdownWithTabs(_ref2) {
  var tabsData = _ref2.tabsData,
      children = _ref2.children,
      onSelectionChange = _ref2.onSelectionChange,
      onTabKeyChange = _ref2.onTabKeyChange,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref2, ["tabsData", "children", "onSelectionChange", "onTabKeyChange"]);

  var _useState = (0, _react.useState)(tabsData[0].key),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      activeTabKey = _useState2[0],
      setActiveTabKey = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      searchValue = _useState4[0],
      setSearchValue = _useState4[1]; // Selected tab


  var activeTab = (0, _react.useMemo)(function () {
    return tabsData.find(function (tab) {
      return tab.key === activeTabKey;
    }) || {};
  }, [activeTabKey, tabsData]);
  var list = (0, _react.useMemo)(function () {
    return activeTab.list;
  }, [activeTab]); // List from search results

  var filteredList = (0, _react.useMemo)(function () {
    return filterList(list, searchValue);
  }, [list, searchValue]);

  var _useCheckAll = (0, _hooks.useCheckAll)(filteredList, onSelectionChange),
      indeterminate = _useCheckAll.indeterminate,
      checkAll = _useCheckAll.checkAll,
      checkedList = _useCheckAll.checkedList,
      handleCheckAllChange = _useCheckAll.handleCheckAllChange,
      handleChange = _useCheckAll.handleChange;

  var handleChangeSeach = (0, _react.useCallback)(function (_ref3) {
    var target = _ref3.target;
    setSearchValue(target.value);
  }, []);
  var handleChangeTab = (0, _react.useCallback)(function (key) {
    setActiveTabKey(key);
    onTabKeyChange(key);
  }, [onTabKeyChange]);
  var searchField = (0, _jsxRuntime.jsx)("div", {
    css: _Dropdown2.styles.item,
    children: (0, _jsxRuntime.jsx)(_DropdownWithCheckbox.SearchField, {
      name: "search",
      placeholder: "Search for ".concat(activeTabKey, "..."),
      onChange: handleChangeSeach,
      value: searchValue
    })
  }); // Tabs

  var tabs = (0, _jsxRuntime.jsx)("div", {
    css: _Dropdown2.styles.item,
    className: "grui pb-3",
    children: (0, _jsxRuntime.jsx)(_Tabs["default"], {
      className: "grui pb-0",
      tabs: tabsData,
      type: "small",
      onChange: handleChangeTab,
      defaultActiveKey: activeTabKey
    })
  });

  var menuWithCheckboxes = function menuWithCheckboxes(listData) {
    return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [tabs, searchField, (0, _jsxRuntime.jsxs)(Menu, {
        children: [filteredList.length > 0 && (0, _jsxRuntime.jsx)(Menu.Item, {
          highlight: true,
          itemKey: "all",
          children: (0, _jsxRuntime.jsx)(_Checkbox["default"], {
            id: selectAllId,
            indeterminate: indeterminate,
            onChange: handleCheckAllChange,
            checked: checkAll,
            value: "",
            children: checkAll ? 'Unselect all' : 'Select all'
          })
        }, "all"), listData.map(function (_ref4) {
          var value = _ref4.value,
              remainingProps = (0, _objectWithoutProperties2["default"])(_ref4, ["value"]);
          return (0, _jsxRuntime.jsx)(Menu.Item, {
            itemKey: value,
            children: (0, _jsxRuntime.jsx)(_DropdownWithCheckbox.CheckboxWithCenteredLabel, {
              id: value,
              onChange: handleChange,
              checked: checkedList.some(function (item) {
                return item.value === value;
              }),
              value: value,
              truncate: true,
              children: activeTab.ListItem ? activeTab.ListItem(remainingProps) : remainingProps.label
            })
          }, value);
        })]
      })]
    });
  };

  return (0, _jsxRuntime.jsx)(_Dropdown["default"], _objectSpread(_objectSpread({
    overlay: menuWithCheckboxes(filteredList),
    hasMinWidth: true,
    autoHeight: true
  }, otherProps), {}, {
    children: children
  }));
};

DropdownWithTabs.propTypes = {
  /**
   * Tabs: includes tabName and selections
   */
  tabsData: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    key: _propTypes.string.isRequired,
    tabName: _propTypes.string.isRequired,
    ListItem: _propTypes.func,
    data: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      id: _propTypes.string,
      value: _propTypes.string,
      label: _propTypes.string,
      avatar: _propTypes.string
    }))
  })).isRequired,
  children: _propTypes.node,

  /**
   * Function(checkedList)
   */
  onSelectionChange: _propTypes.func,

  /**
   * Handle tab key change: Function(key)
   */
  onTabKeyChange: _propTypes.func
};
DropdownWithTabs.defaultProps = {
  children: undefined,
  onSelectionChange: function onSelectionChange() {},
  onTabKeyChange: function onTabKeyChange() {}
};
var _default = DropdownWithTabs;
exports["default"] = _default;
//# sourceMappingURL=DropdownWithTabs.js.map